import IBromcomProviderConfig from "../../../models/misconfig/bromcom/BromcomProviderConfig";
import React, {useState, useEffect} from "react";
import { Col, Row } from "react-bootstrap";
import IConfigJson from "../../../models/misconfig/ConfigJson";
import BiometricFilterView from "../biometric-filter-view";

export default function BromcomProviderConfigView(props: IConfigJson) {
    const [BromcomConfig, setBromcomConfig] = useState<IBromcomProviderConfig | null>(null);

    useEffect(() => {
        if (props.configJson) {
            const configObj: IBromcomProviderConfig = JSON.parse(props.configJson);
            setBromcomConfig(configObj);
        }
    }, [props.configJson]);

    return (
        <React.Fragment>
            <Row>
                <Col md={4} className="pb-2"><b>School ID</b></Col>
                <Col md={8}>{BromcomConfig?.SchoolID}</Col>
            </Row>
            <Row>
                <Col md={4} className="pb-2"><b>Application Version</b></Col>
                <Col md={8}>{BromcomConfig?.ApplicationVersion}</Col>
            </Row>
            <BiometricFilterView filter={BromcomConfig?.BiometricConsents}/> 
            <Row>
                <Col md={12} className="pb-2"><i><b>Medical conditions filters</b></i></Col>
            </Row>
             <Row>
                <Col md={4} className="pb-2 ps-4"><b>Dietary needs</b></Col>
                <Col md={8}>{BromcomConfig?.MedicalConditionsFilter?.DietaryNeeds.join(", ")}</Col>
            </Row>
            <Row>
                <Col md={4} className="pb-2 ps-4"><b>Dietary preferences</b></Col>
                <Col md={8}>{BromcomConfig?.MedicalConditionsFilter?.DietaryPreferences.join(", ")}</Col>
            </Row>   
        </React.Fragment>
    );    
}